import { IDropdownItem } from '@dcl/ui/dist/modules/Dropdown';
import { ReactNode } from 'react';
import { ILocaleDropdownData } from './types';

export const filterProduct = (
  value: string,
  stateDropDownList: ILocaleDropdownData[]
) => {
  const selected = stateDropDownList.filter(
    (item: ILocaleDropdownData) => item.value === value
  );

  if (selected.length) return selected[0].value;

  return '';
};

export const filterFn = (
  items: IDropdownItem[],
  value: ReactNode
): IDropdownItem[] => {
  if (typeof value !== 'string') return [];

  const label = value.toLowerCase();

  return items.filter((item) => item.label.toLowerCase().includes(label));
};

export function constructLocaleUrl(
  stateUrlPath: string,
  state: string
): string {
  let currentUrl = window.location.origin;
  const baseUrl = currentUrl.includes('localhost')
    ? 'https://www-tr-com-qa-ams.ewp.thomsonreuters.com'
    : currentUrl;
  return `${baseUrl}${stateUrlPath}/${state}.hscontentexporter.json`;
}
